import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	overflow-y: auto;
	height: 100%;
`;

export const Close = styled.a`
	color: ${tokens.color_gray_dark};
	cursor: pointer;
	text-decoration: underline;

	padding-top: 25px;
`;

export const Title = styled.p`
	font-weight: 600;
	margin: auto;
	font-size: 16px;
	display: flex;
	place-items: center;
	text-align: center;
	color: ${tokens.color_gray_dark};

	padding-top: 35px;
	padding-bottom: 25px;
`;

export const List = styled.ul`
	padding: 5px 0 40px 10px;
	width: 380px;
	list-style: inside;

	color: ${tokens.color_gray_dark};

	li:nth-child(n + 2) {
		margin-top: 15px;
	}
`;
